import Vue from "vue";

export default {
  async list() {
    const response = await Vue.axios.get("comments");
    return response.data;
  },

  async get(id) {
    const response = await Vue.axios.get(`comments/${id}`);
    return response.data;
  },

  async create(data) {
    const response = await Vue.axios.post("comments", data);
    return response.data;
  },

  async update(id, data) {
    const response = await Vue.axios.put(`comments/${id}`, data);
    return response.data;
  },

  async delete(id) {
    const response = await Vue.axios.delete(`comments/${id}`);
    return response;
  }
};
